(function () {
  'use strict'

  /**
     * @ngdoc directive
     * @name thismomentGlowModuleImagePromo
     * @module thismoment.glow.component.module.image-promo
     *
     * @description
     * The image promotion module for glow
     *
     * @example <pre><code>&#x3C;thismoment-glow-image-promo id=&#x22;1&#x22;&#x3E;&#x3C;/thismoment-glow-image-promo&#x3E;</code></pre>
     */

  require('./scss/module-image-promo.scss')

  var MODULE_NAME = 'thismoment.glow.component.module.image-promo'
  var templateUrl = require('./tpl/module-image-promo.html')

  angular
    .module(MODULE_NAME, [
    ])
    .component('thismomentGlowModuleImagePromo', {
      templateUrl: templateUrl,
      bindings: {
        trackEvent: '&',
        moduleId: '<',
        name: '<',
        backgroundColor: '<',
        imageFile: '<',
        imageFileAltText: '<',
        linkUrl: '<',
        margin: '<',
        mobileBackgroundColor: '<',
        mobileImage: '<',
        mobileImageAltText: '<',
        mobileMargin: '<',
        windowTarget: '<'
      },
      controller: glowImagePromoController
    })

  glowImagePromoController.$inject = ['$scope', 'SdkConfig']
  function glowImagePromoController ($scope, SdkConfig) {
    var vm = this

    vm.styles = vm.classes = {}

    vm.$onInit = imagePromoInit

    $scope.$on('breakpoint:resize', function (event) {
      imagePromoInit()
      $scope.$apply()
    })

    function imagePromoInit () {
      var backgroundColor
      var image
      var margin

      switch (SdkConfig.get('breakpoint')) {
        case 'xs':
        case 'sm':
          // styles
          image = vm.mobileImage || vm.imageFile
          $scope.image = image.url
          backgroundColor = vm.mobileBackgroundColor || vm.backgroundColor
          margin = vm.mobileMargin || vm.margin

          // accessibility
          vm.imageAltText = vm.mobileImageAltText || vm.imageFileAltText
          break

        case 'md':
        case 'lg':
          // styles
          $scope.image = vm.imageFile.url
          backgroundColor = vm.backgroundColor
          margin = vm.margin

          // accessibility
          vm.imageAltText = vm.imageFileAltText
          break
      }

      vm.styles = {
        wrapper: {
          'background-color': backgroundColor,
          'margin': margin
        }
      }

      vm.trackImagePromoClick = trackImagePromoClick
    }

    function trackImagePromoClick (url) {
      vm.trackEvent({
        action: 'Module Converted',
        properties: {
          'event trigger': 'clicked image promo',
          'event trigger detail': url
        }
      })
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-image-promo/index.js